<div
  class="w-full flex items-center justify-center bg-light p-4"
  style="min-height: calc(100vh - 70px)"
>
  <div class="flex justify-center items-center">
    <div *ngIf="isLoading" class="flex flex-col items-center space-y-3">
      <svg
        class="animate-spin h-10 w-10 text-primary"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          class="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          stroke-width="4"
        ></circle>
        <path
          class="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v8z"
        ></path>
      </svg>
      <p class="text-gray-600 text-lg font-medium">Cargando compañías...</p>
    </div>
    <ng-container
      *ngIf="!isLoading && companies.length === 0 && !showCreateForm"
    >
      <div
        class="flex flex-col w-auto max-w-4xl px-3 lg:px-0 h-96 lg:w-[1200px] mx-auto items-center justify-center text-center animate-fade-in bg-white"
      >
        <h2 class="text-2xl font-bold mb-4 text-gray-700">
          Aún no tienes una compañía creada
        </h2>
        <p class="text-gray-500 mb-6">
          Empieza creando tu primera compañía para comenzar a gestionar tus
          ofertas de empleos.
        </p>
        <button
          (click)="showCreateForm = true"
          class="bg-primary text-white px-6 py-3 rounded-lg shadow-md hover:bg-primary/95 transition-all duration-300"
        >
          Crear compañía
        </button>
      </div>
    </ng-container>
    <ng-container *ngIf="!isLoading && showSection()">
      <div
        class="bg-white w-auto lg:w-[1200px] mx-auto p-2 sm:p-6 rounded-md overflow-y-auto"
        style="min-height: calc(100vh - 120px)"
      >
        <div class="flex items-center mb-6">
          <button
            class="text-black flex items-center justify-center hover:text-primary cursor-pointer"
            (click)="showCreateForm = false"
          >
            <ng-icon name="ionChevronBackOutline" size="20"></ng-icon>
          </button>
          <h2 class="text-2xl font-bold text-gray-800 ml-5">
            Crear nueva compañía
          </h2>
        </div>
        <form
          [formGroup]="companyForm.form"
          (ngSubmit)="onSubmit()"
          class="space-y-6"
        >
          <div class="flex flex-col items-center mb-8">
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Logo de la compañía (JPG, máx. 2MB)
            </label>
            <div class="relative w-32 h-32 mb-4">
              <div
                class="w-full h-full rounded-full border-4 border-primary overflow-hidden shadow-md bg-gray-100 flex items-center justify-center"
                (click)="showModalUpdate = true"
              >
                <img
                  *ngIf="croppedImage"
                  [src]="croppedImage"
                  alt="Previsualización"
                  class="object-cover w-full h-full"
                />
                <span
                  *ngIf="!croppedImage"
                  class="text-xs text-gray-400 text-center"
                >
                  Seleccionar imagen
                </span>
              </div>
            </div>
          </div>
          <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            <app-input-select
              label="Departamento"
              placeholder="Seleccione departamento"
              [control]="companyForm.form.get('idDepartament')"
              [options]="departaments"
              (change)="handleDepartmentChange($event)"
            ></app-input-select>
            <app-input-select
              label="Provincia"
              placeholder="Seleccione provincia"
              [control]="companyForm.form.get('idProvince')"
              [options]="provinces"
              (change)="handleProvinceChange($event)"
              [disabled]="companyForm.form.get('idProvince')?.disabled ?? true"
            ></app-input-select>
            <app-input-select
              label="Distrito"
              placeholder="Seleccione distrito"
              [control]="companyForm.form.get('idDistrict')"
              [options]="districts"
              [disabled]="companyForm.form.get('idDistrict')?.disabled ?? true"
            ></app-input-select>
            <app-input-select
              label="Línea de negocio"
              placeholder="Seleccione línea de negocio"
              [control]="companyForm.form.get('businessLine')"
              [options]="bussinessLines"
            ></app-input-select>
            <app-input-text
              label="Correo"
              placeholder="Correo electrónico"
              [control]="companyForm.form.get('email')"
            />
            <app-input-text
              label="RUC"
              placeholder="RUC"
              [control]="companyForm.form.get('ruc')"
            />
            <app-input-text
              label="Nombre comercial"
              placeholder="Nombre comercial"
              [control]="companyForm.form.get('commercialName')"
            />
            <app-input-text
              label="Razón social"
              placeholder="Razón social"
              [control]="companyForm.form.get('legalName')"
            />
          </div>
          <div class="mt-6 w-full sm:w-1/2 md:w-1/4">
            <app-loading-button
              [text]="'Crear compañía'"
              [loading]="isLoadingForm"
              type="submit"
            >
            </app-loading-button>
          </div>
        </form>
      </div>
    </ng-container>
    <ng-container *ngIf="!isLoading && companies.length > 0 && !showCreateForm">
      <div
        class="animate-fade-in-up w-full max-w-7xl mx-auto bg-white overflow-y-auto p-6 md:p-10 rounded-md"
        style="min-height: calc(100vh - 120px)"
      >
        <div
          class="flex flex-col md:flex-row items-start md:items-center justify-between mb-6 gap-4"
        >
          <h2 class="text-2xl font-bold text-gray-800">Tus compañías</h2>
          <button
            (click)="showCreateForm = true"
            class="bg-primary text-white px-6 py-3 rounded-lg hover:bg-primary/95 transition-all duration-300"
          >
            Crear compañía
          </button>
        </div>
        <div
          class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6"
        >
          <div
            *ngFor="let company of companies"
            (click)="selectCompany(company.idCompany)"
            class="bg-white rounded-xl p-6 cursor-pointer transform transition-transform hover:scale-105 hover:shadow-lg border border-gray-200 hover:border-primary group flex flex-col justify-between"
          >
            <div>
              <h3
                class="text-lg font-semibold text-gray-800 group-hover:text-primary truncate-2-lines"
              >
                {{ company.commercialName }}
              </h3>
              <p class="text-sm text-gray-500 mt-2 truncate-2-lines">
                {{ company.socialReason }}
              </p>
              <p class="text-xs text-gray-400 mt-4 truncate-2-lines">
                Línea de negocio: {{ company.businessLine }}
              </p>
            </div>
            <div class="mt-4 flex justify-center">
              <button
                (click)="
                  goToCompany(company.idCompany); $event.stopPropagation()
                "
                class="text-sm cursor-pointer bg-primary text-white px-4 py-2 rounded-lg transition"
              >
                Administrar
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<app-image-upload-modal
  *ngIf="showModalUpdate"
  [loading]="modalLoading"
  (close)="showModalUpdate = false"
  (imageSelected)="onImageSelected($event)"
>
</app-image-upload-modal>
